export default __webpack_public_path__ + "static/softclipper-bg-1102ff5200a67c18d538edc6f8e05487.png";